import AOVVerticalCards from './AOVVerticalCards';

export default AOVVerticalCards;